import { Grid, Typography, useMediaQuery, Theme, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Table, Pagination } from '../../../components';
import { FC, Fragment, useState } from 'react';
import { IOrderHistory } from '../../../models';
import { formatDate, UNDEFINED_PART } from '../../../helpers';
import { MobilePartsHistory } from './parts-history-mobile';
import { PartsHistoryOrderModal } from './parts-history-order-modal';

interface IPartsHistory {
  history: IOrderHistory[];
  isLoadingHistory: boolean;
  page: number;
  perPage: number;
  setRowsPerPage: (val: number) => void;
  recordCount: number;
  setPage: (val: number) => void;
  fetchHistory: (page?: number, rowsPerPage?: number) => void;
}

export const PartsHistory: FC<IPartsHistory> = ({ isLoadingHistory, history, page, perPage, recordCount, setPage, setRowsPerPage, fetchHistory }) => {
  const isMobile = useMediaQuery('(max-width: 1200px)');
  const classes = useStyles();

  const [fieldOrderId, setFieldOrderId] = useState(null);
  const [showPartHistoryOrderModal, setShowPartHistoryOrderModal] = useState(false);
  return (
    <Grid item xs={12}>
      <Typography variant="h6" paragraph>
        Parts History
      </Typography>
      <div className={classes.tableWrapper}>
        <Table
          columns={[
            {
              Header: 'Date',
              accessor: 'dateOrdered',
              sort: false,
              Cell: ({
                cell: {
                  row: { original }
                }
              }: {
                cell: { row: { original: IOrderHistory } };
              }) => {
                return <>{formatDate(original.dateOrdered)}</>;
              }
            },
            {
              Header: 'Order',
              accessor: 'fieldOrderId',
              sort: false,
              Cell: ({
                cell: {
                  row: { original }
                }
              }: {
                cell: { row: { original: IOrderHistory } };
              }) => {
                return (
                  <Button
                    onClick={e => {
                      setShowPartHistoryOrderModal(true);
                      setFieldOrderId(original.fieldOrderId);
                    }}
                    variant="text"
                    color="primary"
                  >
                    {original.fieldOrderId}
                  </Button>
                );
              }
            },
            {
              Header: 'Part',
              accessor: 'part',
              sort: false,
              Cell: ({
                cell: {
                  row: { original }
                }
              }: {
                cell: { row: { original: IOrderHistory } };
              }) => {
                return <Typography className={original.part === UNDEFINED_PART ? classes.undefinedPart : undefined}>{original.part}</Typography>;
              }
            },
            {
              Header: 'Qty.',
              accessor: 'quantity',
              sort: false
            },
            {
              Header: 'Status',
              accessor: 'status',
              sort: false
            }
          ]}
          isLoading={isLoadingHistory}
          data={history || []}
          hidePagination
          ResponsiveComponent={isMobile ? MobilePartsHistory : undefined}
          mobileBreakPoint={1200}
          mobileProps={{
            setShowPartHistoryOrderModal,
            setFieldOrderId
          }}
        />
      </div>
      <PartsHistoryOrderModal open={showPartHistoryOrderModal} onClose={() => setShowPartHistoryOrderModal(false)} fieldOrderId={fieldOrderId} />
      {history && history.length > 0 && (
        <div className={classes.paginationWrapper}>
          <Pagination
            page={page}
            count={recordCount}
            rowsPerPage={perPage}
            setPage={val => {
              if (val !== page) {
                fetchHistory(val, perPage);
              }
              setPage(val);
            }}
            setRowsPerPage={val => {
              if (val !== perPage) {
                fetchHistory(0, val);
              }
              setPage(0);
              setRowsPerPage(val);
            }}
          />
        </div>
      )}
    </Grid>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  tableWrapper: {
    [theme.breakpoints.up('md')]: {
      maxHeight: '30rem',
      overflow: 'auto'
    }
  },
  paginationWrapper: {
    margin: theme.spacing(0.5, 0)
  },
  undefinedPart: {
    color: theme.palette.error.main
  }
}));
